export default __webpack_public_path__ + "static/media/Marquis-Elegance.0df003e8.mp4";